import routeHelper from "helpers/route"

export default routeHelper.lazyLoadRoute(() => import(/* webpackChunkName: "PageHardware" */ "containers/PageHardware"), "containers/PageHardware")
